import { RefundForm } from "../../jobs-flow/RefundForm";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { QuoteInvoiceFormInterface } from "../abstracts/mixins/QuoteInvoiceFormInterface";

export class Invoice extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'invoice';
        this.urlRoot = '/jobs-flow/invoice';
        this.sectionRootUrl = '/jobs-flow';
        this.id = id;

        Object.assign(Invoice.prototype, FormActions);
        Object.assign(Invoice.prototype, EntityModalForm);
        Object.assign(Invoice.prototype, HasStatus);
        Object.assign(Invoice.prototype, QuoteInvoiceFormInterface);
    }

    static statusList = {
        'due': 1,
        'paid': 2,
        'paid-cash': 3,
        'overdue': 4,
        'voided': 5,
        'refunded': 6,
        'partially-refunded': 7,
        'pending': 8,
        'declined': 9,
        'disputed': 10,
        'draft': 11,
        'uncollectable': 12
    }

    refundForm(invoice=this) {
        invoice.openModal('refund');
        new RefundForm(invoice);
    }

    markAsPaidCash(){
        return new Promise((resolve)=>{
            try{
                $.ajax({
                    method: 'POST',
                    url: `${this.urlRoot}/${this.id}/set-paid-cash`,
                    data: null,
                    success: (response) => {
                        resolve(response?.success)
                    },
                    error: err=>{
                        console.error(err)
                        resolve(false)
                    }
                });
            }catch(err){
                console.error(err)
                resolve(false)
            }
        })
    }

    saveAsDraft(successCallback=()=>{}, errorCallback=()=>{}) {
        $.ajaxSetup({
            data: { status: 11 }
        });

        this.id ? this.update({success: successCallback, error: errorCallback}) : this.create({success: successCallback, error: errorCallback});
    }
}
